import {
    FaYoutube,
    FaLinkedin,
    FaVideo,
    FaCode
    
}
from "react-icons/fa";



import data_engineering_pre_modules from "./2026/data_engineering_pre_modules.json";


export const timer = {
    status: true,
    duration: 15 * 60,
    threshold: 5 * 60,
};
const config = import.meta.env.VITE_CONFIG || "npntraining";
console.log(config)
export const sessionDuration = 1000 * 60 * 60; // Default time 1 hour (in milliseconds)

export const coursesList = {
    "07102026":{
        homePage: "https://docs.google.com/document/d/e/2PACX-1vQm2Z2nphFN53Kwx_XjkWHMcZIMSVCBR74AvklCjN4Via5a8gvboovGBXlmmaG4QJsPQt4NeWnTdZZi/pub?embedded=true",
        reportPage: "",
        plannerPage: "",
        askQuestionsPage: "",
        expiryDate: "12/30/2026",
        moduleOverrideFirst :data_engineering_pre_modules,       
        globalTitles: {
        header: {
            logo: "/Logo.png",
            title: "Edforce",
            courseTitle: "Databricks Certified Data Engineer Associate",
        },
            socialHandles: [{
                    id: "linkedIn",
                    url: "https://www.linkedin.com/in/naveen-pn/",
                    icon: FaLinkedin,
                }
            ],
            appointment: "https://topmate.io/naveenpn",
            footer: {
                copyRights: `@ ${new Date().getFullYear()} Edforce PVT Ltd. All Rights Reserved`,
                maintainence: "Developed and Managed by Edforce",
            },
        },
        
    },
 "02062026":{
        homePage: "https://docs.google.com/document/d/e/2PACX-1vQm2Z2nphFN53Kwx_XjkWHMcZIMSVCBR74AvklCjN4Via5a8gvboovGBXlmmaG4QJsPQt4NeWnTdZZi/pub?embedded=true",
        reportPage: "",
        plannerPage: "",
        askQuestionsPage: "",
        expiryDate: "12/30/2026",
        moduleOverrideFirst :data_engineering_pre_modules,
       
        globalTitles: {
        header: {
            logo: "/Logo.png",
            title: "Edforce",
            courseTitle: "Microsoft Fabric Data Engineering (DP-700)",
        },
            socialHandles: [{
                    id: "linkedIn",
                    url: "https://www.linkedin.com/in/naveen-pn/",
                    icon: FaLinkedin,
                }
            ],
            appointment: "https://topmate.io/naveenpn",
            footer: {
                copyRights: `@ ${new Date().getFullYear()} Edforce PVT Ltd. All Rights Reserved`,
                maintainence: "Developed and Managed by Edforce",
            },
        },
        
    },
    "13072026":{
        homePage: "https://docs.google.com/document/d/e/2PACX-1vQm2Z2nphFN53Kwx_XjkWHMcZIMSVCBR74AvklCjN4Via5a8gvboovGBXlmmaG4QJsPQt4NeWnTdZZi/pub?embedded=true",
        reportPage: "",
        plannerPage: "",
        askQuestionsPage: "",
        expiryDate: "12/30/2026",
        moduleOverrideFirst :data_engineering_pre_modules,
       
        globalTitles: {
        header: {
            logo: "/Logo.png",
            title: "Edforce",
            courseTitle: "Microsoft Fabric Data Engineering (DP-700)",
        },
            socialHandles: [{
                    id: "linkedIn",
                    url: "https://www.linkedin.com/in/naveen-pn/",
                    icon: FaLinkedin,
                }
            ],
            appointment: "https://topmate.io/naveenpn",
            footer: {
                copyRights: `@ ${new Date().getFullYear()} Edforce PVT Ltd. All Rights Reserved`,
                maintainence: "Developed and Managed by Edforce",
            },
        },
        
    },"24082026":{
        homePage: "https://docs.google.com/document/d/e/2PACX-1vQm2Z2nphFN53Kwx_XjkWHMcZIMSVCBR74AvklCjN4Via5a8gvboovGBXlmmaG4QJsPQt4NeWnTdZZi/pub?embedded=true",
        reportPage: "",
        plannerPage: "",
        askQuestionsPage: "",
        expiryDate: "12/30/2026",
        moduleOverrideFirst :data_engineering_pre_modules,
       
        globalTitles: {
        header: {
            logo: "/Logo.png",
            title: "Edforce",
            courseTitle: "Databricks Certified Data Engineer Associate",
        },
            socialHandles: [{
                    id: "linkedIn",
                    url: "https://www.linkedin.com/in/naveen-pn/",
                    icon: FaLinkedin,
                }
            ],
            appointment: "https://topmate.io/naveenpn",
            footer: {
                copyRights: `@ ${new Date().getFullYear()} Edforce PVT Ltd. All Rights Reserved`,
                maintainence: "Developed and Managed by Edforce",
            },
        },
        
    },"07092026":{
        homePage: "https://docs.google.com/document/d/e/2PACX-1vQm2Z2nphFN53Kwx_XjkWHMcZIMSVCBR74AvklCjN4Via5a8gvboovGBXlmmaG4QJsPQt4NeWnTdZZi/pub?embedded=true",
        reportPage: "",
        plannerPage: "",
        askQuestionsPage: "",
        expiryDate: "12/30/2026",       
        globalTitles: {
        header: {
            logo: "/Logo.png",
            title: "Edforce",
            courseTitle: "Google Associate Data Practitioner",
        },
            socialHandles: [{
                    id: "linkedIn",
                    url: "https://www.linkedin.com/in/naveen-pn/",
                    icon: FaLinkedin,
                }
            ],
            appointment: "https://topmate.io/naveenpn",
            footer: {
                copyRights: `@ ${new Date().getFullYear()} Edforce PVT Ltd. All Rights Reserved`,
                maintainence: "Developed and Managed by Edforce",
            },
        },
        
    },"15092026":{
        homePage: "https://docs.google.com/document/d/e/2PACX-1vQm2Z2nphFN53Kwx_XjkWHMcZIMSVCBR74AvklCjN4Via5a8gvboovGBXlmmaG4QJsPQt4NeWnTdZZi/pub?embedded=true",
        reportPage: "",
        plannerPage: "",
        askQuestionsPage: "",
        expiryDate: "12/30/2026",
        moduleOverrideFirst :data_engineering_pre_modules,       
        globalTitles: {
        header: {
            logo: "/Logo.png",
            title: "Edforce",
            courseTitle: "Microsoft Fabric Data Engineering (DP-700)",
        },
            socialHandles: [{
                    id: "linkedIn",
                    url: "https://www.linkedin.com/in/naveen-pn/",
                    icon: FaLinkedin,
                }
            ],
            appointment: "https://topmate.io/naveenpn",
            footer: {
                copyRights: `@ ${new Date().getFullYear()} Edforce PVT Ltd. All Rights Reserved`,
                maintainence: "Developed and Managed by Edforce",
            },
        },
        
    }

};
